// Design System Constants for Neumorphic UI

export const colors = {
  light: {
    background: '#e0e5ec',
    cardBg: '#e0e5ec',
    textPrimary: '#2c3e50',
    textSecondary: '#7f8c9a',
    shadowLight: '#ffffff',
    shadowDark: '#a3b1c6',
    accentBlue: '#667eea',
    accentGreen: '#48bb78',
    accentRed: '#f56565',
    accentOrange: '#ed8936',
    accentYellow: '#f6ad55',
    accentPurple: '#9f7aea',
    border: '#cbd5e0',
  },
  dark: {
    background: '#1a202c',
    cardBg: '#2d3748',
    textPrimary: '#f7fafc',
    textSecondary: '#a0aec0',
    shadowLight: '#374151',
    shadowDark: '#0f1419',
    accentBlue: '#667eea',
    accentGreen: '#48bb78',
    accentRed: '#f56565',
    accentOrange: '#ed8936',
    accentYellow: '#f6ad55',
    accentPurple: '#9f7aea',
    border: '#4a5568',
  },
};

export const typography = {
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  sizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
  },
  weights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
};

export const spacing = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  '2xl': '3rem',
  '3xl': '4rem',
};

export const borderRadius = {
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  full: '9999px',
};

// Neumorphic Shadow Utilities
export const getNeumorphicShadow = (theme) => {
  const { shadowLight, shadowDark } = colors[theme];
  return `12px 12px 24px ${shadowDark}, -12px -12px 24px ${shadowLight}`;
};

export const getNeumorphicInset = (theme) => {
  const { shadowLight, shadowDark } = colors[theme];
  return `inset 6px 6px 12px ${shadowDark}, inset -6px -6px 12px ${shadowLight}`;
};

export const getNeumorphicHover = (theme) => {
  const { shadowLight, shadowDark } = colors[theme];
  return `16px 16px 32px ${shadowDark}, -16px -16px 32px ${shadowLight}`;
};

// Animation Configurations
export const animations = {
  fast: 0.15,
  normal: 0.3,
  slow: 0.5,
  spring: {
    type: 'spring',
    stiffness: 260,
    damping: 20,
  },
};

// Breakpoints
export const breakpoints = {
  mobile: 375,
  tablet: 768,
  desktop: 1024,
  wide: 1440,
};
